/**
 * util for generating common sizes for tailwind config
 * note: unused sizes will be pruned, so no need to worry about bloating the css
 */
export function generateSizes(amount) {
    const entries = Array.from({ length: amount }, (_, i) => i + 1).map((i) => {
        const oneBasedIndex = i + 1;
        return [oneBasedIndex, `${oneBasedIndex * 4}px`];
    });
    return Object.fromEntries(entries);
}
